// Static directory copy only; never used for authorization or changing saved grants.
const rows = `
Close|Schließen|Zamknij
Identity Manager|Identitätsverwaltung|Zarządzanie użytkownikami
Search…|Suchen…|Szukaj…
Reload|Neu laden|Wczytaj ponownie
Refresh|Aktualisieren|Odśwież
Loading users…|Benutzer werden geladen…|Wczytywanie użytkowników…
Loading…|Wird geladen…|Wczytywanie…
Retry|Erneut versuchen|Spróbuj ponownie
Error:|Fehler:|Błąd:
Name|Name|Imię i nazwisko
E-Mail|E-Mail|E-mail
Role|Rolle|Rola
Status|Status|Status
Action|Aktion|Działanie
No results for|Keine Ergebnisse für|Brak wyników dla
No users found for this property.|Keine Benutzer für dieses Hotel gefunden.|Nie znaleziono użytkowników tego hotelu.
No users found.|Keine Benutzer gefunden.|Nie znaleziono użytkowników.
Failed to load users.|Benutzer konnten nicht geladen werden.|Nie udało się wczytać użytkowników.
Failed to load staff.|Mitarbeiter konnten nicht geladen werden.|Nie udało się wczytać pracowników.
Permissions: {{value}}|Berechtigungen: {{value}}|Uprawnienia: {{value}}
HOS Permissions|HOS-Berechtigungen|Uprawnienia HOS
Package|Paket|Pakiet
Fine|Einzelrecht|Pojedyncze uprawnienie
Implicit|Implizit|Pośrednie
Switches marked "Implicit" do not need an explicit grant.|Als „Implizit“ markierte Rechte benötigen keine ausdrückliche Zuweisung.|Uprawnienia oznaczone jako „Pośrednie” nie wymagają osobnego nadania.
Global administrator: every permission is granted implicitly.|Globaler Administrator: Alle Berechtigungen werden implizit gewährt.|Administrator globalny: wszystkie uprawnienia są nadane pośrednio.
Identity Manager Access (admin.access) grants every permission implicitly.|Der Zugriff auf die Identitätsverwaltung (admin.access) gewährt alle Berechtigungen implizit.|Dostęp do zarządzania użytkownikami (admin.access) nadaje pośrednio wszystkie uprawnienia.
Granted implicitly: global administrator|Implizit gewährt: globaler Administrator|Nadane pośrednio: administrator globalny
Granted implicitly: Identity Manager Access (admin.access) includes every permission|Implizit gewährt: Zugriff auf die Identitätsverwaltung (admin.access) umfasst alle Berechtigungen|Nadane pośrednio: dostęp do zarządzania użytkownikami (admin.access) obejmuje wszystkie uprawnienia
Granted implicitly by a saved permission package|Implizit durch ein gespeichertes Berechtigungspaket gewährt|Nadane pośrednio przez zapisany pakiet uprawnień
Staff directory — read-only view of USM-managed accounts.|Mitarbeiterverzeichnis — schreibgeschützte Ansicht der USM-Konten.|Lista pracowników — podgląd kont zarządzanych w USM, tylko do odczytu.
Accounts, roles, hotel assignments and module permissions are managed in Xentros User Management. Changes take effect at the user's next login.|Konten, Rollen, Hotelzuordnungen und Modulberechtigungen werden in Xentros User Management verwaltet. Änderungen gelten ab der nächsten Anmeldung.|Konta, role, przypisania do hoteli i uprawnienia modułów są zarządzane w Xentros User Management. Zmiany obowiązują od następnego logowania użytkownika.
No staff found.|Keine Mitarbeiter gefunden.|Nie znaleziono pracowników.
No staff found for {{property}}.|Keine Mitarbeiter für {{property}} gefunden.|Nie znaleziono pracowników dla {{property}}.
Could not load staff list ({{status}})|Mitarbeiterliste konnte nicht geladen werden ({{status}})|Nie udało się wczytać listy pracowników ({{status}})
Could not load permissions ({{status}})|Berechtigungen konnten nicht geladen werden ({{status}})|Nie udało się wczytać uprawnień ({{status}})
Active|Aktiv|Aktywne
Inactive|Inaktiv|Nieaktywne
Blocked|Gesperrt|Zablokowane
Pending|Ausstehend|Oczekujące
Disabled|Deaktiviert|Wyłączone
Invited|Eingeladen|Zaproszone
Administrator|Administrator|Administrator
Global administrator|Globaler Administrator|Administrator globalny
Hotel manager|Hotelleitung|Kierownik hotelu
Receptionist|Rezeption|Recepcjonista
User|Benutzer|Użytkownik
Permission Packages|Berechtigungspakete|Pakiety uprawnień
Property Management|Hotelverwaltung|Zarządzanie hotelem
Point of Sale|Kassensystem|Punkt sprzedaży
Engineering|Haustechnik|Dział techniczny
Warehouse|Lager|Magazyn
Revenue|Umsatz|Przychody
VoIP|VoIP|VoIP
Guests & CRM|Gäste und CRM|Goście i CRM
CCTV|CCTV|CCTV
Keycoder|Schlüsselkodierung|Kodowanie kluczy
Garage|Parkhaus|Parking
User Management|Benutzerverwaltung|Zarządzanie użytkownikami
Admin Access|Administratorzugriff|Dostęp administratora
Other permissions|Weitere Berechtigungen|Pozostałe uprawnienia
Identity Manager Access|Zugriff auf die Identitätsverwaltung|Dostęp do zarządzania użytkownikami
PMS Front Desk Package|PMS-Rezeptionspaket|Pakiet recepcji PMS
PMS Reservations Package|PMS-Reservierungspaket|Pakiet rezerwacji PMS
PMS Groups & Blocks Package|PMS-Gruppen- und Blockpaket|Pakiet grup i bloków PMS
PMS Housekeeping Package|PMS-Housekeeping-Paket|Pakiet sprzątania PMS
PMS Billing Package|PMS-Abrechnungspaket|Pakiet rozliczeń PMS
PMS Advanced Billing Package|PMS-Paket für erweiterte Abrechnung|Pakiet zaawansowanych rozliczeń PMS
PMS Night Audit Package|PMS-Tagesabschlusspaket|Pakiet audytu nocnego PMS
PMS Reports Package|PMS-Berichtspaket|Pakiet raportów PMS
Revenue View Package|Umsatzansichtspaket|Pakiet podglądu przychodów
Revenue Management Package|Umsatzverwaltungspaket|Pakiet zarządzania przychodami
Garage Operations Package|Parkhaus-Betriebspaket|Pakiet obsługi parkingu
Garage Management Package|Parkhaus-Verwaltungspaket|Pakiet zarządzania parkingiem
EMS Operations Package|EMS-Betriebspaket|Pakiet obsługi EMS
EMS Management Package|EMS-Verwaltungspaket|Pakiet zarządzania EMS
Dashboard View|Dashboard anzeigen|Podgląd pulpitu
Check-In|Einchecken|Zameldowanie
Check-Out|Auschecken|Wymeldowanie
Check-In – Override unmet requirements|Einchecken – unerfüllte Voraussetzungen übersteuern|Zameldowanie – pominięcie niespełnionych wymagań
Create Users|Benutzer erstellen|Tworzenie użytkowników
Edit Users|Benutzer bearbeiten|Edycja użytkowników
Disable Users|Benutzer deaktivieren|Wyłączanie użytkowników
Delete Users|Benutzer löschen|Usuwanie użytkowników
Live View|Live-Ansicht|Podgląd na żywo
Incidents|Vorfälle|Incydenty
Rooms|Zimmer|Pokoje
Reservations|Reservierungen|Rezerwacje
Groups|Gruppen|Grupy
Block Inventory|Blockkontingent|Pula pokoi bloku
Block Rates|Blockpreise|Ceny bloku
Block Cutoff|Blockabrufschluss|Termin zwolnienia bloku
Rooming List|Zimmerbelegungsliste|Lista gości grupy
Group Billing|Gruppenabrechnung|Rozliczenia grupowe
Group Payments|Gruppenzahlungen|Płatności grupowe
Group Documents|Gruppendokumente|Dokumenty grupowe
Groups Audit|Gruppen-Audit|Audyt grup
Group Sales Pipeline|Gruppenvertriebspipeline|Lejek sprzedaży grupowej
Group Sales Opportunities|Gruppenverkaufschancen|Szanse sprzedaży grupowej
Guests|Gäste|Goście
Billing|Abrechnung|Rozliczenia
Housekeeping|Housekeeping|Sprzątanie
Rates|Preise|Ceny
Night Audit|Tagesabschluss|Audyt nocny
Reports|Berichte|Raporty
Sales|Verkauf|Sprzedaż
Cashier|Kasse|Kasa
Tables|Tische|Stoliki
Menu|Speisekarte|Menu
Assets|Anlagen|Zasoby
Maintenance|Instandhaltung|Konserwacja
Inventory|Bestand|Zapasy
Orders|Bestellungen|Zamówienia
Suppliers|Lieferanten|Dostawcy
Analytics|Analysen|Analityka
Pricing|Preisgestaltung|Zarządzanie cenami
Calls|Anrufe|Połączenia
Config|Konfiguration|Konfiguracja
Profiles|Profile|Profile
Communication|Kommunikation|Komunikacja
Loyalty|Treueprogramm|Program lojalnościowy
Recordings|Aufzeichnungen|Nagrania
Cards|Karten|Karty
Devices|Geräte|Urządzenia
Parking|Parken|Parking
Settings|Einstellungen|Ustawienia
View|Anzeigen|Podgląd
Update|Aktualisieren|Aktualizacja
Assign|Zuweisen|Przypisanie
Create|Erstellen|Tworzenie
Edit|Bearbeiten|Edycja
Cancel|Stornieren|Anulowanie
No-Show|Nichtanreise|Niepojawienie się
Manage|Verwalten|Zarządzanie
Override|Übersteuern|Nadpisanie
Release|Freigeben|Zwolnienie
Import|Importieren|Import
Post Charge|Belastung buchen|Księgowanie opłaty
Accept Payment|Zahlung annehmen|Przyjmowanie płatności
Discount|Rabatt|Rabat
Void / Refund|Storno / Rückerstattung|Anulowanie / zwrot
Comp|Kostenfrei stellen|Świadczenie bezpłatne
Transfer|Übertragen|Przeniesienie
Close Invoice|Rechnung abschließen|Zamknięcie faktury
Update Status|Status ändern|Zmiana statusu
Assign Tasks|Aufgaben zuweisen|Przydział zadań
Run|Ausführen|Uruchomienie
Financial|Finanzen|Finansowe
Void|Storno|Anulowanie
Open Till|Kasse öffnen|Otwarcie kasy
Payment|Zahlung|Płatność
Refund|Rückerstattung|Zwrot
Adjust|Anpassen|Korekta
Approve|Genehmigen|Zatwierdzanie
Receive|Empfangen|Przyjmowanie
Export|Exportieren|Eksport
Send|Senden|Wysyłanie
Issue|Ausstellen|Wydawanie
Cancel / Revoke|Stornieren / widerrufen|Anulowanie / cofnięcie
`;
const entries = rows.trim().split("\n").map(row => row.split("|"));
export const identityUiResources = {
  en: Object.fromEntries(entries.map(([en]) => [en, en])),
  de: Object.fromEntries(entries.map(([en, de]) => [en, de])),
  pl: Object.fromEntries(entries.map(([en, , pl]) => [en, pl])),
};
